/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContactusContent } from '../../models/contactus-content';

export interface ApiMasterContactusContentGetAllGet$Params {
}

export function apiMasterContactusContentGetAllGet(http: HttpClient, rootUrl: string, params?: ApiMasterContactusContentGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ContactusContent>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterContactusContentGetAllGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ContactusContent>>;
    })
  );
}

apiMasterContactusContentGetAllGet.PATH = '/api/Master/ContactusContent/GetAll';
